/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Nav_ChangelogInputs */

const en_footer_nav_changelog = /** @type {(inputs: Footer_Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changelog`)
};

const tr_footer_nav_changelog = /** @type {(inputs: Footer_Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sürüm Notları`)
};

/**
* | output |
* | --- |
* | "Changelog" |
*
* @param {Footer_Nav_ChangelogInputs} inputs
* @param {{ locale?: "en" | "tr" }} options
* @returns {LocalizedString}
*/
export const footer_nav_changelog = /** @type {((inputs?: Footer_Nav_ChangelogInputs, options?: { locale?: "en" | "tr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Nav_ChangelogInputs, { locale?: "en" | "tr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_nav_changelog(inputs)
	return tr_footer_nav_changelog(inputs)
});